// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/workflow.js#1 $
'use strict';

/**
* @ngdoc service
* @name tcApp.WorkflowService
* @description
* Workflow service contains logic related to component navigation and workflows.
*/
angular.module('tcApp')
.factory('WorkflowService', function($location, $http, $route, $rootScope, $window,
										ComponentCache, RouteParamsCache, SystemRouter, GlobalService,
										BreadcrumbService, ComponentListService) {
	/**
	 * @description
	 * Returns whether the passed URL contains a breadcrumb-level (&Dialog=) parameter
	 * @param {string} url URL to find the Dialog parameter for
	 * @returns {boolean}
	 */
	var urlHasDialogLevel = function(url) {
		return (angular.isString(url) && (url.search(/(?:&|\?)Dialog=/) !== -1));
	};

	var getNextLevelUrl = function getNextLevelUrl(url) {
		var depth = ($location.search().Dialog ? parseInt($location.search().Dialog, 10) : 0);
		depth = depth + 1;
		if (urlHasDialogLevel(url)) {
			// Prevent duplicate &Dialog= parameter, replace any existing one with the new value
			return url.replace(/(&|\?)Dialog=\d*/, ('$1Dialog=' + depth));
		}
		return (url + ((url.indexOf('?') === -1) ? '?' : '&') + 'Dialog=' + depth);
	};

	var lockMessages,lockMessagesAlwaysShow;
	var checkSession = function(componentName, params, cachedData) {
		var locksToRestoreClassNames = [];
		var locksToRestoreIds = [];
		var locksToRestoreComponentNames = [];
		getLocksToRestore(cachedData.data, locksToRestoreClassNames, locksToRestoreIds, locksToRestoreComponentNames);
		return SystemRouter.checkSession(componentName, params,
										locksToRestoreClassNames, locksToRestoreIds, locksToRestoreComponentNames)
		.then(function afterCheckSession(response) {
			// If IRIS logon page is served, session has expired.
			// If IRIS logon is not configured, sessionExpired flag will be picked up by httpDataConfig
			if ((response.data) && (!angular.isObject(response.data))) {
				$window.location.href = (GlobalService.getAppClassName() + '#/Component/SSUserLogon');
				$window.location.reload();
			} else if (response.data) {
				// Always update the latest counters, and restore any previously acquired locks
				if (response.data.counters) GlobalService.updateCounters(response.data.counters);
				if (locksToRestoreClassNames.length > 0) {
					lockMessages = response.data.messages;
					lockMessagesAlwaysShow = response.data.messagesAlwaysShow;
					$rootScope.$broadcast('Component:getComponentHtmlName', componentName, restoreLocks);
				}
			}
		});
	};

	// Returns all locks that need to be restored across both the component and nested components.
	// locksToRestoreClassNames, locksToRestoreIds & locksToRestoreComponentNames parameters are modified and passed back
	var getLocksToRestore = function(componentData,
									locksToRestoreClassNames, locksToRestoreIds, locksToRestoreComponentNames) {
		if (angular.isUndefined(componentData)) return;

		angular.forEach(componentData.locks, function(lock) {
			locksToRestoreClassNames.push(lock.className);
			locksToRestoreIds.push(lock.id);
			locksToRestoreComponentNames.push(componentData.componentName);
		});
		angular.forEach(componentData.items, function(item) {
			if (angular.isUndefined(item.displayType) || (item.displayType !== 'CX')
			|| angular.isUndefined(item.componentData)) return;

			// Recursive call to get all locks for descendant components
			getLocksToRestore(item.componentData, locksToRestoreClassNames, locksToRestoreIds, locksToRestoreComponentNames);
		});

		return;
	};

	var restoreLocks = function(componentHtmlName) {
		if (angular.isDefined(componentHtmlName) && angular.isArray(lockMessages)
			&& (lockMessages.length > 0)) {
			$rootScope.$broadcast('Component:restoreLocks', componentHtmlName, lockMessages, lockMessagesAlwaysShow);
		}
	};

	var getCachedOrNewData = function getCachedOrNewData() {
		var cachedData, cachedParams, chartId;
		var params = angular.copy($route.current.params);
		cachedData = ComponentCache.getComponentData(params);
		if (!WorkflowService.fetchNewChartData) cachedParams = RouteParamsCache.get($location.url());
		if (cachedParams) params = cachedParams;
		if ((cachedData) && (!WorkflowService.fetchNewChartData)) {
			// Check for expired session, and clear patient context when banner is not displayed (e.g. ward list/floorplan)
			checkSession($route.current.params.componentName, params, cachedData);
			return cachedData;
		}
		WorkflowService.fetchNewChartData = false;
		if ($location.path() == '/OrderEntry') {
			return $http.post('system.Router.cls?TORDERENTRY=1', params);
		} else if (($route.current.params.chartBookId) || ($route.current.params.chartId)) {
			var chartBookId = ($route.current.params.chartBookId ? $route.current.params.chartBookId : '');
			chartId = ($route.current.params.chartId ? $route.current.params.chartId : '');
			var chartItem = ($route.current.params.chartItem ? $route.current.params.chartItem : '');
			return $http.post('system.Router.cls?TCHARTBOOK=' + chartBookId +
								'&TCHART=' + chartId + '&TCHARTITEM=' + chartItem, params);
		} else if ((angular.isDefined($route.current.params.worklistName))
					|| ($location.path().indexOf('/Worklist') !== -1)) {
			var worklistName = ($route.current.params.worklistName ? $route.current.params.worklistName : 'TMAIN');
			return $http.post('system.Router.cls?TWORKLIST=' + worklistName , params);
		} else {
			return $http.post('system.Router.cls?TENFORCETUID=1&TCOMPONENT=' + $route.current.params.componentName, params);
		}
	};

	/**
	 * @description
	 * Returns the current dialog level by default, or alternatively the dialog level for the passed URL
	 * @param {string=} url Optional URL for which to extract the dialog level
	 * @returns {number} Current or extracted dialog level
	 */
	var getDialogLevel = function(url) {
		var dialogLevel = 0;
		if (angular.isString(url)) {
			var dialogMatch = url.match(/(?:&|\?)Dialog=(\d+)/);
			if ((dialogMatch !== null) && angular.isDefined(dialogMatch[1])) {
				dialogLevel = parseInt(dialogMatch[1], 10);
			}
		} else if (angular.isDefined($route.current) && angular.isDefined($route.current.params)) {
			dialogLevel = parseInt($route.current.params.Dialog, 10);
		}
		// Handles NaN value
		return ((dialogLevel > 0) ? dialogLevel : 0);
	};

	/**
	 * @description
	 * Returns the parent dialog level
	 * @returns {number} Parent dialog level
	 */
	var getParentDialogLevel = function() {
		var dialogLevel = 0;
		if (angular.isDefined($route.current) && angular.isDefined($route.current.params)) {
			dialogLevel = parseInt($route.current.params.Dialog, 10);
		}
		return ((dialogLevel > 0) ? (dialogLevel - 1) : 0);
	};

	/**
	 * @description
	 * Records navigateAwayChecks added from component Scripts via websys.js:navigateAwayAddCheck
	 */
	var addNavigateAwayCheck = function(componentName, msg) {
		if (angular.isUndefined(WorkflowService.navigateAwayChecks)) WorkflowService.navigateAwayChecks = {};
		var navigateAwayCheck = {};
		navigateAwayCheck.message = msg;
		navigateAwayCheck.breadcrumbIndex = BreadcrumbService.data.breadcrumbs.length - 1;
		WorkflowService.navigateAwayChecks[componentName] = navigateAwayCheck;
	};
	
	var navigateAwayCompleteCheck = function(componentName) {
		if (angular.isUndefined(WorkflowService.navigateAwayChecks)) WorkflowService.navigateAwayChecks = {};
		if (angular.isDefined(WorkflowService.navigateAwayChecks[componentName])) {
			delete WorkflowService.navigateAwayChecks[componentName];
		}
	};


	var onLoadHandler = function(newScope) {
		// if TCTSRCH has been set and current component has CTSRCH item, trigger find event
		if ((WorkflowService.TCTSRCH != '') && (angular.isDefined(newScope.data.items.CTSRCH))) {
			newScope.data.items.CTSRCH.value = WorkflowService.TCTSRCH;
			WorkflowService.TCTSRCH = ''; // Clear value so we only do this once
			if (angular.isDefined(newScope.data.items.find1)) {
				GlobalService.triggerEvent({eventItemName: 'find1', componentHtmlName: newScope.componentHtmlName});
				return;
			}
		}

		var dialogLevel = WorkflowService.getDialogLevel();
		var reloadFunction = WorkflowService.getReloadFunction(dialogLevel);
		if (angular.isUndefined(reloadFunction) || (!angular.isFunction(newScope[reloadFunction.name]))) return;

		WorkflowService.removeReloadFunctionForDialogLevel(dialogLevel);
		newScope[reloadFunction.name].call(newScope,
			(angular.isDefined(reloadFunction.returnValue) ? reloadFunction.returnValue : ''));
	};
	
	/**
	 * @description
	 * Adds a reload function to the map for the specified dialog level.
	 * Uses the current dialog level by default.
	 * The reload function will be called on navigation back to that dialog level.
	 * @param {string} reloadFunctionName The name of the reload function to add to the map
	 * @param {number | string | undefined} dialogLevel Dialog level for which to map the reload function
	 * @returns {boolean} Returns true if the reloadFunctionName passed is valid
	 */
	var addReloadFunctionToMap = function(reloadFunctionName, dialogLevel) {
		if (!angular.isString(reloadFunctionName)) return false;
		reloadFunctionName = reloadFunctionName.split('(')[0];
		if (angular.isUndefined(reloadFunctionName) || (reloadFunctionName === '')) return false;

		// This is usually invoked from the target component, which will use the parent or current dialog level depending on
		// whether we are stepped into a workflow. If no dialogLevel is passed, default to current level to maintain consistency
		if (angular.isUndefined(dialogLevel) || (dialogLevel === '')) {
			dialogLevel = WorkflowService.getDialogLevel();
		}
		if (!angular.isObject(WorkflowService.reloadFunctionMap[dialogLevel])) {
			WorkflowService.reloadFunctionMap[dialogLevel] = {};
		}
		WorkflowService.reloadFunctionMap[dialogLevel].name = reloadFunctionName;
		return true;
	};
	
	/**
	 * @description
	 * Removes the reload function mapped to the specified dialog level.
	 * Uses the current dialog level by default.
	 * @param {number | string | undefined} dialogLevel Dialog level for which to remove any mapped reload function
	 */
	var removeReloadFunctionForDialogLevel = function(dialogLevel) {
		if (angular.isUndefined(dialogLevel) || (dialogLevel === '')) {
			dialogLevel = WorkflowService.getDialogLevel();
		}
		delete WorkflowService.reloadFunctionMap[dialogLevel];
	};
	
	/**
	 * @description
	 * Removes mapped reload functions for all dialog levels below the specified level.
	 * Uses the current dialog level by default.
	 * @param {number | string | undefined} dialogLevel Dialog level for which to remove any lower mapped reload functions
	 */
	var removeReloadFunctionsForDescendantDialogLevels = function(dialogLevel) {
		if (angular.isUndefined(dialogLevel) || (dialogLevel === '')) {
			dialogLevel = WorkflowService.getDialogLevel();
		}
		var mapLevels = Object.keys(WorkflowService.reloadFunctionMap);
		if (!mapLevels.length) return;

		mapLevels.forEach(function(mapLevel) { // eslint-disable-line angular/foreach
			if (parseInt(mapLevel, 10) <= dialogLevel) return;

			delete WorkflowService.reloadFunctionMap[mapLevel];
		});
	};

	/**
	 * @description
	 * Sets a returnValue for a mapped reload function at the specified dialog level.
	 * Uses the current dialog level by default.
	 * @param {any} returnValue The return value to set
	 * @param {number | string | undefined} dialogLevel Dialog level for which to remove any mapped reload function
	 * @param {string=} reloadFunctionName When passed, will target the returnValue to a specific reload function
	 * @returns {boolean} Returns true if there was a matching reload function found for which to set the value
	 */
	var setReloadFunctionReturnValue = function(returnValue, dialogLevel, reloadFunctionName) {
		if (angular.isUndefined(dialogLevel) || (dialogLevel === '')) {
			dialogLevel = WorkflowService.getDialogLevel();
		}
		if (!angular.isObject(WorkflowService.reloadFunctionMap[dialogLevel])) {
			return false;
		}
		if (angular.isString(reloadFunctionName) && (reloadFunctionName !== '')
			&& (WorkflowService.reloadFunctionMap[dialogLevel].name !== reloadFunctionName)) {
			return false;
		}

		WorkflowService.reloadFunctionMap[dialogLevel].returnValue = returnValue;
		return true;
	};
	
	/**
	 * @description
	 * Gets the mapped reload function for the specified dialog level.
	 * Uses the current dialog level by default.
	 * @param {string=} dialogLevel Dialog level for which to get the mapped reload function
	 * @returns {Object | undefined} Mapped reload function object
	 */
	var getReloadFunction = function(dialogLevel) {
		if (angular.isUndefined(dialogLevel) || (dialogLevel === '')) {
			dialogLevel = WorkflowService.getDialogLevel();
		}
		if ((!angular.isObject(WorkflowService.reloadFunctionMap[dialogLevel]))
			|| (!angular.isString(WorkflowService.reloadFunctionMap[dialogLevel].name))
			|| (WorkflowService.reloadFunctionMap[dialogLevel].name === '')) {
				return;
		}
		return WorkflowService.reloadFunctionMap[dialogLevel];
	};
	
	/**
	 * Handles reload functions set from embedded pages (TCUI or custom CSPs via websys_callInUrl)
	 * returnValue can be passed separately as the second parameter, or as part of reloadFunctionNameAndValue
	 * @param {string} reloadFunctionNameAndValue Reload function name, optionally including the ('returnValue')
	 * @param {any} returnValue The return value when not passed as part of reloadFunctionNameAndValue
	 */
	var setReloadFunctionFromEmbeddedPage = function(reloadFunctionNameAndValue, returnValue) {
		if (!angular.isString(reloadFunctionNameAndValue)) return;

		var reloadFunctionName = reloadFunctionNameAndValue.split('(')[0];
		var dialogLevel = WorkflowService.getParentDialogLevel();
		if (angular.isString(reloadFunctionName) && (reloadFunctionName !== '')) {
			WorkflowService.addReloadFunctionToMap(reloadFunctionName, dialogLevel);
			returnValue = (angular.isDefined(returnValue) ? returnValue : reloadFunctionNameAndValue.split('"')[1]);
			if (angular.isDefined(returnValue)) {
				WorkflowService.setReloadFunctionReturnValue(returnValue, dialogLevel, reloadFunctionName);
			}
		} else {
			WorkflowService.removeReloadFunctionForDialogLevel(dialogLevel);
		}
	};

	var WorkflowService = {
		fetchNewChartData: false,
		fetchReloadComponent: '',
		isInCloseReload: false,
		isInReload: false,
		reloadFunctionMap: {},
		TCTSRCH: '',
		addReloadFunctionToMap: addReloadFunctionToMap,
		getCachedOrNewData: getCachedOrNewData,
		addNavigateAwayCheck: addNavigateAwayCheck,
		navigateAwayCompleteCheck: navigateAwayCompleteCheck,
		getDialogLevel: getDialogLevel,
		getNextLevelUrl: getNextLevelUrl,
		getParentDialogLevel: getParentDialogLevel,
		getReloadFunction: getReloadFunction,
		onLoadHandler: onLoadHandler,
		removeReloadFunctionForDialogLevel: removeReloadFunctionForDialogLevel,
		removeReloadFunctionsForDescendantDialogLevels: removeReloadFunctionsForDescendantDialogLevels,
		setReloadFunctionFromEmbeddedPage: setReloadFunctionFromEmbeddedPage,
		setReloadFunctionReturnValue: setReloadFunctionReturnValue,
		urlHasDialogLevel: urlHasDialogLevel,
	};

	/* eslint-disable angular/on-watch */
	$rootScope.$on('$routeChangeStart', function onRouteChangeHandleWorkflow($event, newRoute, oldRoute) {
		WorkflowService.fetchReloadComponent = '';
		// When not reloading, preserve the dialog level if it happens to be missing on the new route
		if (!WorkflowService.isInCloseReload && !WorkflowService.isInReload
			&& oldRoute && oldRoute.params.Dialog && !newRoute.params.Dialog) {
			newRoute.params.Dialog = oldRoute.params.Dialog;
		}
		var dialogLevel = parseInt(newRoute.params.Dialog, 10);
		dialogLevel = (!isNaN(dialogLevel) ? dialogLevel : '');
		if (WorkflowService.isInCloseReload || WorkflowService.isInReload) {
			var cacheKey = angular.toJson(newRoute.params);
			var reloadFunction = WorkflowService.getReloadFunction(dialogLevel);
			if (angular.isUndefined(reloadFunction)) {
				if (angular.isDefined(newRoute.params.componentName)) {
					// If there is no TRELOADJS function, add a mapping for the standard _Reload()
					WorkflowService.fetchReloadComponent = newRoute.params.componentName;
					WorkflowService.addReloadFunctionToMap(newRoute.params.componentName.replace(/\./g, '_') + '_Reload',
						dialogLevel);
				} else {
					// For non-Component routes, remove the cache to request new data
					ComponentCache.remove(cacheKey);
				}
			}
			ComponentListService.clearAllListCollapsedCache(cacheKey);
			WorkflowService.isInCloseReload = false;
			WorkflowService.isInReload = false;
		}
		// Always remove any leftover mapped functions for descendant levels
		WorkflowService.removeReloadFunctionsForDescendantDialogLevels(dialogLevel);
	});

	// Check for any custom NavigateAwayChecks
	$rootScope.$on('$locationChangeStart', function onLocationChangeStart($event, newUrl, oldUrl) {
		// Don't allow direct route for an existing session
		if ((newUrl.indexOf('#/Direct/') !== -1) && (oldUrl.indexOf('#/Direct/') === -1)
			&& (oldUrl.indexOf('#/LogonSuccess') === -1)) {
			$event.preventDefault();
			return;
		}
		// Don't do this when replacing url (e.g. navigating from /Workflow to first Workflow Item)
		if ($location.tkReplaced) return;

		var currentDialogLevel = WorkflowService.getDialogLevel(oldUrl);
		var newDialogLevel = WorkflowService.getDialogLevel(newUrl);
		// If not opening in higher dialog level look for navigateAway checks
		if (newDialogLevel <= currentDialogLevel) {
			// Determine if we are going back in breadcrumbs
			var breadCrumbBackIndex = '';
			angular.forEach(BreadcrumbService.data.breadcrumbs, function(breadcrumb, index) {
				if (breadcrumb.linkUrl === $location.url()) {
					breadCrumbBackIndex = index;
				}
			});

			var confirmedCheckKeys = [];
			if (angular.isDefined(WorkflowService.navigateAwayChecks)) {
				angular.forEach(WorkflowService.navigateAwayChecks, function(item, key) {
					var checkIndex = item.breadcrumbIndex;
					// Main menu or breadrcumb back
					if ((WorkflowService.mainMenuData) ||
						((breadCrumbBackIndex !== '') && (breadCrumbBackIndex < checkIndex))) {
						if (!$window.confirm(item.message)) {
							$event.preventDefault();
						} else {
							confirmedCheckKeys.push(key);
						}
					}
				});
			}
			// If no custom check was cancelled, check default confirmUnload.
			if (!$event.defaultPrevented) {
				// Broadcast event to confirmUnload.js
				$rootScope.$broadcast('Workflow:locationChangeStart', newUrl, newDialogLevel, currentDialogLevel);
				if (WorkflowService.navigateAwayPrevented) {
					$event.preventDefault();
				} else {
					var unloadHandlersRun = false;
					// If no checks were cancelled, delete any that were confirmed.
					angular.forEach(confirmedCheckKeys,  function(key) {
						delete WorkflowService.navigateAwayChecks[key];
						// Will only work if corresponding component is currently on the screen
						// May need some way of running unload functions for previous breadcrumbs later
						$rootScope.$broadcast('Component:runUnloadHandlers', key);
						unloadHandlersRun = true;
					});

					// If going back in breadcrumbs or Main Menu and didn't already run unload handler for navigateAwayCheck
					if (((angular.isDefined(WorkflowService.mainMenuData)) || (breadCrumbBackIndex !== ''))
						&& (!unloadHandlersRun)) {
						$rootScope.$broadcast('Component:runUnloadHandlers');
					}

					// If mainMenuData has been set (e.g. Main Menu click, Workflow loop, Home button)
					if (angular.isDefined(WorkflowService.mainMenuData)) {
						WorkflowService.reloadFunctionMap = {};
						// broadcast mainMenuSelected event if we did not cancel the navigation
						$rootScope.$broadcast('tcMenu:MainMenuSelected', WorkflowService.mainMenuData.caption);
					}
				}
			}
		}
		// Reset WorkflowService params
		delete WorkflowService.mainMenuData;
		WorkflowService.navigateAwayPrevented = false;
		WorkflowService.confirmUnloadPrompted = false;
	});

	return WorkflowService;
});
